'use client';

import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';

function getDebugger(): ComponentType {
	// Only include the debugger when running locally
	if (process.env.NODE_ENV !== 'development') {
		return () => null;
	}

	return dynamic(async () => import('./JotaiDebugging'), {
		ssr: false,
	});
}

const DevOnlyJotaiDebugging = getDebugger();

export { DevOnlyJotaiDebugging };
